var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalogClock = function SvgAnalogClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 71,
    height: 70,
    viewBox: "0 0 71 70"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35,
    r: 32.5,
    fill: "#fff",
    stroke: "#a2bc3a",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d490f",
    d: "M35.5 16c10.48 0 19 8.52 19 19s-8.52 19-19 19-19-8.52-19-19 8.52-19 19-19Zm0 2.71A16.27 16.27 0 0 0 19.21 35c0 9.01 7.28 16.29 16.29 16.29 9.01 0 16.29-7.28 16.29-16.29 0-9.01-7.28-16.29-16.29-16.29Zm0 4.75c.75 0 1.36.61 1.36 1.36V35c0 .5-.28.93-.68 1.17l-7.64 4.4c-.64.38-1.49.17-1.86-.48a1.35 1.35 0 0 1 .5-1.85l6.96-4.02v-9.4c0-.75.61-1.36 1.36-1.36Z"
  })));
};
export default SvgAnalogClock;